import React, {Component} from 'react';
import pack from '../package.json';
import './App.css';

import OverdoseCard from './containers/OverdoseCard.js';
import DemographicsCard from './containers/DemographicsCard.js';

import NationalCard from './containers/NationalCard.js';
import StateCard from './containers/StateCard.js';
import CountyCard from './containers/CountyCard.js';
import DetailCard from './containers/DetailCard.js';

import {Layout} from 'antd';

import bnl from './data/bnl-logo.svg';
import FacebookShare from "./components/FacebookShare";
import TwitterShare from "./components/TwiiterShare";

const {Header, Content, Footer} = Layout;

class App extends Component {
  render() {
    return (
      <Layout style={{height: '100%'}}>
        <Header className="header">
          <div className="logo"/>
          <b className="app-title"><span className="hidden-sm-down">American</span> Opioid Epidemic</b>
          <div className="bnl">
            <a href="http://bnlconsulting.com" target="_blank" rel="noopener noreferrer">
              <img src={bnl} alt="BNL logo"/>
            </a>
          </div>
        </Header>
        <Content>
          <OverdoseCard/>
          <DemographicsCard/>
          <NationalCard/>
          <StateCard/>
          <CountyCard/>
          <DetailCard/>
        </Content>
        <Footer style={{textAlign: 'center'}}>
          Opioid Epidemic POC - v{pack.version}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          ©{new Date().getFullYear()}
          <a href="http://bnlconsulting.com"> BNL Consulting</a>&nbsp;and&nbsp;
          <a href="https://www.magpiehealthanalytics.com/">Magpie Health Analytics</a>
          <div className="share-buttons">
            <TwitterShare/>
            <FacebookShare/>
          </div>
        </Footer>
      </Layout>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js